import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useLocation } from "react-router-dom";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowConsent(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowConsent(false);
  };

  if (!showConsent) return null;

  // Detect language from URL
  const isEnglish = location.pathname.startsWith("/en");
  const isGerman = location.pathname.startsWith("/de");
  const isPortuguese = location.pathname.startsWith("/pt");
  const isFrench = location.pathname.startsWith("/fr");

  const content = {
    es: {
      title: "🍪 Uso de Cookies",
      message: "Utilizamos cookies esenciales para garantizar el funcionamiento correcto del sitio web y mejorar tu experiencia. No utilizamos cookies de seguimiento.",
      accept: "Aceptar",
      reject: "Rechazar",
      privacy: "Política de Privacidad",
      link: "/privacidad"
    },
    en: {
      title: "🍪 Cookie Usage",
      message: "We use essential cookies to ensure the website functions correctly and improve your experience. We do not use tracking cookies.",
      accept: "Accept",
      reject: "Reject",
      privacy: "Privacy Policy",
      link: "/en/privacy"
    },
    de: {
      title: "🍪 Cookie-Nutzung",
      message: "Wir verwenden essenzielle Cookies, um die ordnungsgemäße Funktion der Website zu gewährleisten und Ihre Erfahrung zu verbessern. Wir verwenden keine Tracking-Cookies.",
      accept: "Akzeptieren",
      reject: "Ablehnen",
      privacy: "Datenschutzerklärung",
      link: "/de/datenschutz"
    },
    pt: {
      title: "🍪 Uso de Cookies",
      message: "Utilizamos cookies essenciais para garantir o funcionamento correto do site e melhorar sua experiência. Não utilizamos cookies de rastreamento.",
      accept: "Aceitar",
      reject: "Rejeitar",
      privacy: "Política de Privacidade",
      link: "/pt/privacidade"
    },
    fr: {
      title: "🍪 Utilisation des Cookies",
      message: "Nous utilisons des cookies essentiels pour garantir le bon fonctionnement du site web et améliorer votre expérience. Nous n'utilisons pas de cookies de suivi.",
      accept: "Accepter",
      reject: "Rejeter",
      privacy: "Politique de Confidentialité",
      link: "/fr/privacy"
    }
  };

  const lang = isEnglish ? "en" : isGerman ? "de" : isPortuguese ? "pt" : isFrench ? "fr" : "es";
  const text = content[lang];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-strong animate-in slide-in-from-bottom duration-500">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold mb-2">{text.title}</h3>
            <p className="text-sm text-muted-foreground">
              {text.message}{" "}
              <a href={text.link} className="text-primary underline hover:no-underline">
                {text.privacy}
              </a>
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <Button
              variant="outline"
              onClick={handleReject}
              className="min-w-[100px] min-h-[44px] px-6"
            >
              {text.reject}
            </Button>
            <Button
              onClick={handleAccept}
              className="min-w-[100px] min-h-[44px] px-6"
            >
              {text.accept}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
